import searchReducer from './search.reducer';

export { default as searchActions } from './search.actions';
export { types as searchTypes } from './search.actions';
export { default as searchSelectors } from './search.selectors';

export default searchReducer;
